import { useSelector } from "react-redux"
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material"
import CartItem from "../cart/CartItem"
import GiftCardOrDiscountCodeInput from "../cart/GiftCardOrDiscountCodeInput"
import CartMobileToggleButton from "../cart/CartMobileToggleButton"
import CartSummary from "../cart/CartSummary"
import CartItemSkeleton from "../cart/CartItemSkeleton"
import { DELIVERY_OPTIONS } from "src/app/constants"
import HawaiiGetItem from "../cart/HawaiiGetItem"
import { hasBeerOrSeltzerItemsSelector } from "src/features/checkout/checkoutSlice"
import { useEffect } from "react"

function Cart() {
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down("md"))
  const hasBeerItems = useSelector(hasBeerOrSeltzerItemsSelector)
  const { cart, options, showOrderSummary, cartJsLineItems } = useSelector(
    (state) => state.checkout,
  )

  useEffect(() => {
    console.log('Cart', {cart, options, showOrderSummary, cartJsLineItems})
  }, [])

  return (
    <>
      {!cartJsLineItems && (
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      )}

      <CartMobileToggleButton />

      {(!downMd || showOrderSummary) && (
        <Box margin={2} marginTop={1} maxWidth={downMd ? "inherit" : "560px"}>
          {cart.lines?.edges.length > 0
            ? cart.lines?.edges
                .filter(({ node }) => node.merchandise) // Remove inactive/draft products.
                .map(({ node }) => <CartItem key={node.id} data={node} />)
            : cartJsLineItems.map(({ id }) => <CartItemSkeleton key={id} />)}
          {options.deliveryOption === DELIVERY_OPTIONS.US_MAINLAND_SHIPPING && hasBeerItems && <HawaiiGetItem />}
          <GiftCardOrDiscountCodeInput />
          <CartSummary />
        </Box>
      )}
    </>
  )
}

export default Cart
